import React from 'react';
import MainLayoutHome from '../layout/MainLayoutHome';
import Lilla from '../components/Lilla';

const LillaPage = () => {
  return (
    <MainLayoutHome>
        <Lilla/>
    </MainLayoutHome>
  )
}

export default LillaPage